import React from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {Box, Tab, Tabs} from '@mui/material';
import GlobalSnackbar from '../../shared-components/GlobalSnackbar';

const SchoolManagementPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const onTemplates = location.pathname.startsWith('/management/templates');

    return (
        <>
            <Box sx={{px: 3, borderBottom: '1px solid #e5e7eb'}}>
                <Tabs
                    value={onTemplates ? 1 : 0}
                    onChange={(_, value) => navigate(value === 0 ? '/management' : '/management/templates')}
                >
                    <Tab label="School Workspaces" data-testid="tab-school-workspaces"/>
                    <Tab label="Form Templates" data-testid="tab-form-templates"/>
                </Tabs>
            </Box>
            <Box sx={{px: 3}}>
                <Outlet/>
            </Box>
            <GlobalSnackbar/>
        </>
    );
};

export default SchoolManagementPage;
